import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

export default function ErrorState({
  title = 'Something went wrong',
  description = 'Please refresh and try again.',
  onRetry,
  retryLabel = 'Retry',
  compact = false,
}) {
  return (
    <Box
      sx={{
        minHeight: compact ? 150 : 220,
        borderRadius: 2.5,
        border: '1px solid',
        borderColor: 'error.light',
        backgroundColor: 'background.paper',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: compact ? 2 : 3,
      }}
    >
      <Stack spacing={1.2} alignItems="center" textAlign="center">
        <ErrorOutlineRoundedIcon color="error" sx={{ fontSize: compact ? 28 : 36 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
          {description}
        </Typography>
        {onRetry ? (
          <Button variant="contained" color="error" onClick={onRetry}>
            {retryLabel}
          </Button>
        ) : null}
      </Stack>
    </Box>
  );
}

